import React from 'react';
import {applyPropMutation, getPropMutationState} from '../../model/action-creators/mutation-actions'



// NOTE, this is a QnD and should not be here
export const  appendEditableCell = (className, item, mutation, propName, html)=>{
    let modifiedClass = '';
    let computedHidden = false;
    if ( mutation) {
        const applied = applyPropMutation(item, propName, mutation);
        modifiedClass = getPropMutationState(item, propName, mutation, applied, '', '--changed','');

        // because applied can return Symbol.UNDEFINED
        if (applied===true) {
            computedHidden = true;
        }
    } else {
        computedHidden = item.get(propName, false);
    }
    return ({
            className:className+modifiedClass,
            value:computedHidden?html:'-'}
    );
};



// WEBPACK FOOTER //
// ./src/ui/components/TableUtils.js